import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { exectuionProcessStates } from '../constants';
import { AvlaRestClientService } from 'base-angular-avla';
import { delay, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExecutionProcessService {

	private getExecutionProcessUrl = '/client360-api/getExecutionProcess';
  private percentProgress = new BehaviorSubject<number>(0);
  private statusProgress = new BehaviorSubject<number>(exectuionProcessStates.CREATED);

  public percentProgress$ = this.percentProgress.asObservable();
  public statusProgress$ = this.statusProgress.asObservable();


  constructor(private avlaRestClientService: AvlaRestClientService) {}

  public getExecutionProcess(executionId: number) : Observable<any>{
    return this.avlaRestClientService.getSingle(this.getExecutionProcessUrl, [executionId.toString()], {});
  }


  public getExecutionProcessData(executionId: number) : Observable<any> {
    return this.getExecutionProcess(executionId).pipe(
      delay(1000),
      switchMap( response => {

        this.statusProgress.next(response.status);
        this.setProgressData(response);

        switch (response.status) {
          case exectuionProcessStates.CREATED:
          case exectuionProcessStates.PROCESSING:
            return this.getExecutionProcessData(executionId);
          case exectuionProcessStates.FINISHED_SUCCESS:
          case exectuionProcessStates.FINISHED_ERROR:
            this.resetProgressData();
            return of(response);
          default:
            return of(null);
        }
       })
    );
  }

  private setProgressData(response: any) {
    const progressData = response?.progress_data ? JSON.parse(response.progress_data) : null;
    const progress = progressData ? ((progressData?.current/progressData?.total) * 100) : 0;
    this.percentProgress.next(progress);
  }

  private resetProgressData() {
    this.percentProgress.next(100);
    setTimeout(() => {
      this.percentProgress.next(0);
      this.statusProgress.next(exectuionProcessStates.CREATED);
    }, 10000);
  }


  actualizarProgreso(valor: number) {
    this.percentProgress.next(valor);
  }

  actualizarEstado(valor: number) {
    this.statusProgress.next(valor);
  }
}
